/**
 * Generated by orval. Do not edit manually.
 */

export type AnnouncementPlacementChoice =
  (typeof AnnouncementPlacementChoice)[keyof typeof AnnouncementPlacementChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementPlacementChoice = {
  toaster: 'toaster',
  strip_banner: 'strip_banner',
  dashboard_banner: 'dashboard_banner',
  modal: 'modal',
} as const
